import { useDispatch, useSelector } from "react-redux";
import { Button, Container, Message } from "semantic-ui-react";
import { useState } from "react";
import enviroment from "../../enviroment";
import CopyDocument from "../../components/manualInputs/CopyDocument";
import { authAPI } from "../../apis/AuthAPI";
import { responseError } from "../../helpers";

export const HeaderOptions = ({
    area,
    estateManualInputRequest,
    estateManualInput,
    activeTab,
    setActiveTab,
    setShowPropertiesModal,

    clientId,
    assetIndex,
    saveForLaterBtn_Click,
    finishReviewBtn_Click,
    loaderSaveForLater,
    loaderFinishReview
}) => {
    const me = useSelector(state => state.me);
    const [loaderPreview, setLoaderPreview] = useState(false)
    const dispatch = useDispatch();

    const openPreview = async () => {
        setLoaderPreview(true)
        try {
            const {data} = await authAPI.post('/single-token', {
                clientId,
                reviewer: estateManualInputRequest.reviewer,
                advisor: estateManualInputRequest.advisor,
                index: assetIndex
            })
            window.open(`${enviroment.fpalphaUrl}/external-snapshot-preview?token=${data}&area=${area}`,'_blank')
        } catch (error) {
            responseError(error, undefined, "HeaderOptions_AutoHome.openPreview", dispatch)
        }

        setLoaderPreview(false)
    }

    /* const openPreview = async () => {
        setLoaderPreview(true)
        try {
            const isValid = await validateEstatePreview({
                clientId,
                reviewer: estateManualInputRequest.reviewer,
                advisor: estateManualInputRequest.advisor,
                index: assetIndex
            })
            if(!isValid){
                // eslint-disable-next-line
                throw {message: "There is an error in the snapshot, and it cannot be generated.\nPlease notify the development team."}
            }
            const data = await generateToken({
                clientId,
                reviewer: estateManualInputRequest.reviewer,
                advisor: estateManualInputRequest.advisor,
                index: assetIndex
            })
            window.open(`${enviroment.fpalphaUrl}/external-snapshot-preview?token=${data}&area=estate`,'_blank')
        } catch (error) {
            console.log({error})
        }
        setLoaderPreview(false)
    } */

    return (<div>
        <ButtonsToSave
            estateManualInputRequest={estateManualInputRequest}
            saveForLaterBtn_Click={saveForLaterBtn_Click}
            finishReviewBtn_Click={finishReviewBtn_Click}
            loaderSaveForLater={loaderSaveForLater}
            loaderFinishReview={loaderFinishReview}
        />

        <div style={{textAlign: 'right', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'flex-end', rowGap: '0.5rem'}}>
            <Button loading={loaderPreview} color='red' onClick={() => openPreview()}>
                Preview
            </Button>
            <Button color='yellow' onClick={() => setShowPropertiesModal(true)}>
                Add Properties
            </Button>
            {(estateManualInputRequest?.status !== 'Ready' || (estateManualInputRequest?.status === 'Ready' && me.permissions.includes('manual_inputs:open_documents'))) &&
                <Button color='blue' onClick={() => window.open(`/dashboard/estate-manual-input/${clientId}/${area}/files`)}>
                    Open documents
                </Button>
            }
            {activeTab && <>
                <CopyDocument documentToCopy={activeTab} setActiveTab={setActiveTab} />
            </>}
        </div>
    </div>)
}

export const ButtonsToSave = ({estateManualInputRequest, saveForLaterBtn_Click, finishReviewBtn_Click, loaderSaveForLater, loaderFinishReview}) => {    
    const me = useSelector(state => state.me);
    return <>
        {((estateManualInputRequest?.status === 'In review' && estateManualInputRequest?.reviewer?._id === me?._id) || estateManualInputRequest?.status === 'Peer review') &&
            <Container fluid textAlign='right' style={{ margin: '20px 0px' }}>
                <Button color='grey' onClick={() => saveForLaterBtn_Click()} loading={loaderSaveForLater} disabled={loaderSaveForLater}>Save for later</Button>
                <Button style={{ paddingLeft: '50px', paddingRight: '50px' }} disabled={loaderFinishReview} color='green' onClick={() => finishReviewBtn_Click()} loading={loaderFinishReview} >Finish review</Button>
            </Container>
        }
    </>
}

export const FooterOptions = ({estateManualInputRequest, saveForLaterBtn_Click, finishReviewBtn_Click, loaderSaveForLater, loaderFinishReview}) => {
    return <>
        <ButtonsToSave
            estateManualInputRequest={estateManualInputRequest}
            saveForLaterBtn_Click={saveForLaterBtn_Click}
            finishReviewBtn_Click={finishReviewBtn_Click}
            loaderSaveForLater={loaderSaveForLater}
            loaderFinishReview={loaderFinishReview}
        />
        {estateManualInputRequest?.status === 'Ready' &&
            <Message color='green'>This manual input has already been marked as REVIEWED.</Message>
        }
    </>
}